import { useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "src/redux/hooks";

import { useGroupContext } from "../GroupContext";
import LogbooksDrop from "./LogbooksDrop";
export interface Position {
  x: number;
  y: number;
  width: number;
  height: number;
}

const LogbooksSelector = () => {
  const { logbooks } = useSelector(state => state.organizeSlice);
  const { selectedElement } = useGroupContext();
  const assignedRef = useRef<HTMLDivElement>(null);
  const availableRef = useRef<HTMLDivElement>(null);

  const [assignedPosition, setAssignedPosition] = useState<Position>();
  const [availablePosition, setAvailablePosition] = useState<Position>();

  useLayoutEffect(() => {
    if (assignedRef.current && availableRef.current) {
      const as = assignedRef.current.getBoundingClientRect();
      const av = availableRef.current.getBoundingClientRect();

      setAssignedPosition({
        x: as.x,
        y: as.y,
        width: as.width,
        height: as.height,
      });
      setAvailablePosition({
        x: av.x,
        y: av.y,
        width: av.width,
        height: av.height,
      });
    }
  }, []);

  const availableLogs = selectedElement
    ? logbooks.filter(
        log => !selectedElement?.logbooks.map(l => l.lbid).includes(log.lbid),
      )
    : [];
  return (
    <>
      <LogbooksDrop
        ref={assignedRef}
        title="Assigned Logbooks"
        logbooks={selectedElement?.logbooks ?? []}
        targetPosition={availablePosition}
      />
      <LogbooksDrop
        ref={availableRef}
        title="Available Logbooks"
        logbooks={availableLogs ?? []}
        targetPosition={assignedPosition}
      />
    </>
  );
};

export default LogbooksSelector;
